<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <el-card v-if="!editStatus" class="custom-card mb-20" shadow="never">
        <el-button v-if="calcPermission(permition, 1)" round type="danger" icon="el-icon-circle-plus-outline" @click="handleCreate">{{ $t('table.add') }}</el-button>
      </el-card>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!editStatus" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column
            type="index"
            width="100"
            align="center" />
          <el-table-column :label="$t('table.number')" width="250px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.RoleNo">{{ scope.row.RoleNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.name')" width="250px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.RoleName">{{ scope.row.RoleName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.status')" align="center" width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.RStatusNo">{{ scope.row.RStatusNo | PgStatusNoFilter }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center" min-width="100%" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-link v-if="calcPermission(permition, 2)" class="custom-link" type="primary" size="mini" @click="handleUpdate(scope.row)">{{ $t('table.edit') }}</el-link>
              <el-link v-if="calcPermission(permition, 3)" class="custom-link" size="mini" type="danger" @click="handleDelete(scope.row)">{{ $t('table.delete') }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" layout="total, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </el-card>
      </div>
    </transition>
    <!-- 编辑/新增 -->
    <transition name="el-zoom-in-bottom">
      <div v-if="editStatus" class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col class="CommitForm">
              <el-form v-if="commitFrom" ref="commitFrom" :rules="rules" :model="commitFrom" label-position="right" label-width="100px">
                <el-form-item :label="$t('table.number')" prop="RoleNo">
                  <el-input v-model="commitFrom.RoleNo" class="filter-item" placeholder="请输入编号" />
                </el-form-item>
                <el-form-item :label="$t(`table.name`)" prop="RoleName">
                  <el-input v-model="commitFrom.RoleName" class="filter-item" placeholder="请输入名称" />
                </el-form-item>
                <el-form-item :label="$t(`table.status`)" prop="RStatusNo">
                  <el-select v-model="commitFrom.RStatusNo" class="filter-item" placeholder="请选择状态">
                    <el-option v-for="item in calendarTypeOptions" :key="item.key" :label="item.display_name" :value="item.key"/>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t(`table.permission`)" prop="pgMemoArr">
                  <el-select v-model="pgMemoArr" class="filter-item" value-key="PgMemo" multiple placeholder="请选择权限" @change="calcBtn">
                    <el-option
                      v-for="item in RolePrograms"
                      :key="item.PgId"
                      :label="item.PgMemo"
                      :value="item" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t(`table.btnPermission`)">
                  <el-row v-for="item in pgMemoArr" :key="item.PgId" style="display:flex;">
                    <span style="width:100px;">{{ item.PgMemo }}</span>
                    <div style="display:flex;flex-wrap:wrap;width:100%;">
                      <div v-for="(item_, index_) in item.PermitionMemos" :key="index_">
                        <el-checkbox :checked="item.permitionBtnArr[index_]" class="filter-item" style="margin-left:15px;" @change="item.permitionBtnArr[index_]=!item.permitionBtnArr[index_]">{{ item_ }}</el-checkbox>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-left: 60px" round class="filter-item" type="info" @click="cancelCommit">{{ $t('table.cancel') }}</el-button>
          <el-button v-if="calcPermission(permition, 4)" round class="filter-item" type="primary" @click="commitEdit('commitFrom')">{{ $t('table.submit') }}</el-button>

        </el-card>

      </div>
    </transition>
  </div>
</template>
<script>
import { qryProgramInfo, qryRoleInfo, addRoleInfo, modRoleInfo, delRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令
const calendarTypeOptions = [
  { key: 'A', display_name: '启用' },
  { key: 'S', display_name: '禁用' }
]
const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})
export default {
  name: 'RoleManage',
  directives: {
    waves
  },
  filters: {
    PgStatusNoFilter(type) {
      return calendarTypeKeyValue[type]
    }
  },
  data() {
    return {
      editStatus: false,
      list: null,
      total: null,
      listLoading: true,
      tableKey: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      BtnArr: [true, false],
      programList: {
        pageIndex: 1,
        pageSize: 1000
      },
      calendarTypeOptions,
      commitFrom: {
        RoleId: 0,
        RoleNo: '',
        RoleName: '',
        RStatusNo: '',
        ProgramIds: []
        // checkRolePrograms: [],
        // checkPermition: []
      },
      RolePrograms: [],
      currentRoleInfo: null,
      pgMemoArr: [],
      // pgMemoBtnArr: [],
      rules: {
        RoleNo: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        RoleName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        RStatusNo: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        pgMemoArr: [
          { required: false, message: '请选择权限', trigger: 'blur' }
        ]
      },
      permition: 0
    }
  },
  created() {
    qryRoleInfo().then(response => {
      this.$store.state.roleInfo = response
      response.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.modifyRole()
        }
      })
    })
    // if (this.$store.state.roleInfo) {
    //   console.log('172', this.$store.state.roleInfo)
    //   this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
    //     if (this.$route.path === item.ProgramInfo.PgUrl) {
    //       this.permition = item.Permition
    //       this.getList()
    //     }
    //   })
    // } else {
    //   qryRoleInfo().then(response => {
    //     console.log('181', response)
    //     this.$store.state.roleInfo = response
    //     response.LsList[0].RolePrograms.forEach(item => {
    //       if (this.$route.path === item.ProgramInfo.PgUrl) {
    //         this.permition = item.Permition
    //         this.getList()
    //       }
    //     })
    //   })
    // }
  },
  methods: {
    modifyRole() {
      qryRoleInfo(this.listQuery).then(response => {
        console.log(response)
        this.$store.state.roleInfo = response
        this.getList()
      })
    },
    getList() {
      this.listLoading = true
      qryProgramInfo(this.programList).then(response => {
        this.RolePrograms = response.LsList
      })
      this.list = this.$store.state.roleInfo.LsList
      this.total = this.$store.state.roleInfo.TotalRows
      this.commitFrom = {
        RoleId: 0,
        RoleNo: '',
        RoleName: '',
        RStatusNo: '',
        ProgramIds: []
      }
      this.pgMemoArr = []
      this.listLoading = false
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.modifyRole()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.modifyRole()
    },
    handleCreate() {
      this.editStatus = true
    },
    handleUpdate(row) {
      console.log('226', row)
      this.commitFrom.RoleId = row.RoleId
      this.commitFrom.RoleNo = row.RoleNo
      this.commitFrom.RoleName = row.RoleName
      this.commitFrom.RStatusNo = row.RStatusNo
      this.commitFrom.ProgramIds = []
      this.currentRoleInfo = row
      row.RolePrograms.forEach(item => {
        console.log('234', item)
        // 按钮权限值
        item.ProgramInfo.btnPermition = item.Permition
        // 所有按钮数组
        item.ProgramInfo.PermitionMemos = JSON.parse(item.ProgramInfo.PermitionMemo)
        item.ProgramInfo.permitionBtnArr = []
        // 所有按钮权限数组
        item.ProgramInfo.PermitionMemos.forEach((item_, index_) => {
          if (this.calcPermission(item.ProgramInfo.btnPermition, index_ + 1)) {
            item.ProgramInfo.permitionBtnArr.push(true)
          } else {
            item.ProgramInfo.permitionBtnArr.push(false)
          }
        })
        this.pgMemoArr.push(item.ProgramInfo)
      })
      // this.commitFrom.checkRolePrograms = []
      // this.commitFrom.checkPermition = []
      this.editStatus = true
    },
    commitEdit(formName) {
      if (this.pgMemoArr.length === 0) {
        this.$message.warning('请检查数据格式是否正确')
        return false
      } else {
        this.commitFrom.ProgramIds = []
        this.pgMemoArr.forEach(item => {
          var ProgramIds_ = {}
          ProgramIds_.PId = item.PgId
          ProgramIds_.Permition = 0
          item.permitionBtnArr.forEach((item_, index_) => {
            if (item_ === true) {
              ProgramIds_.Permition += Math.pow(2, (30 - index_))
            }
          })
          this.commitFrom.ProgramIds.push(ProgramIds_)
        })
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.commitFrom.RoleId > 0) {
            modRoleInfo(this.commitFrom).then(response => {
              this.modifyRole()
              this.editStatus = false
            })
          } else {
            addRoleInfo(this.commitFrom).then(response => {
              this.modifyRole()
              this.editStatus = false
            })
          }
        } else {
          this.$message.warning('请检查数据格式是否正确')
          return false
        }
      })
    },
    handleDelete(row) {
      this.$alert('该操作不可逆', '您确定要删除么', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            delRoleInfo(row).then(response => {
              this.modifyRole()
            })
          }
        }
      })
    },
    cancelCommit() {
      this.commitFrom = {
        RoleId: 0,
        RoleNo: '',
        RoleName: '',
        RStatusNo: '',
        ProgramIds: []
      }
      this.pgMemoArr = []
      this.editStatus = false
    },
    calcBtn() {
      this.pgMemoArr.forEach(item => {
        if (!item.permitionBtnArr) {
          item.PermitionMemos = JSON.parse(item.PermitionMemo)
          item.permitionBtnArr = []
          // 所有按钮权限数组
          item.PermitionMemos.forEach((item_, index_) => {
            if (this.calcPermission(item.btnPermition, index_ + 1)) {
              item.permitionBtnArr.push(true)
            } else {
              item.permitionBtnArr.push(false)
            }
          })
          this.RolePrograms.forEach((item_, index_) => {
            if (item_.PgId === item.PgId) {
              item.btnPermition = item_.Permition
            }
          })
        }
      })
    }
    // addRoleProgram() {
    //   // this.pgMemoBtnArr = this.pgMemoArr
    //   this.commitFrom.ProgramIds = []
    //   this.pgMemoArr.forEach(item => {
    //     // if (typeof item.PermitionMemo === 'string') {
    //     //   item.PermitionMemo = JSON.parse(item.PermitionMemo)
    //     // }
    //     var ProgramIds_ = {}
    //     ProgramIds_.PId = item.PgId
    //     ProgramIds_.Permition = 2147483647
    //     this.commitFrom.ProgramIds.push(ProgramIds_)
    //   })
    //   // this.commitFrom.checkRolePrograms = this.pgMemoArr
    // }
  }
}
</script>

<style lang="less">
.el-form-item__label{
  float: left;
}
</style>

